export default __webpack_public_path__ + "static/shutterstock_9-29164e64f07b99e2b00b211e317d91bf.jpg";